import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { Observable } from "rxjs";
import { HttpclientService } from "../../../../shared";

@Injectable()
export class IncidentService {
	constructor(private httpclientService: HttpclientService) {}

	InfractionGetList(schoolid) {
		var postResult$ = new Subject();
		var url = "attendance/InfractionGetList?schoolID=" + schoolid;
		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
	PenaltyGetList(schoolid) {
		var postResult$ = new Subject();
		var url = "attendance/PenaltyGetList?schoolID=" + schoolid;
		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}
	IncidentSave(incident) {
		var postResult$ = new Subject();
		var url = "attendance/IncidentSave";

		var promise$ = this.httpclientService.post(url, incident);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
